import { render, staticRenderFns } from "./VillageInfo.vue?vue&type=template&id=399ca458&scoped=true&"
import script from "./VillageInfo.vue?vue&type=script&lang=js&"
export * from "./VillageInfo.vue?vue&type=script&lang=js&"
import style0 from "./VillageInfo.vue?vue&type=style&index=0&id=399ca458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399ca458",
  null
  
)

export default component.exports